
import React from "react";
 
import SettingsIcon from '@mui/icons-material/Settings';
import { Button, ButtonGroup, Dropdown, Form } from "react-bootstrap";

const CheckboxMenu = React.forwardRef(
  (
    {
      children,
      style,
      className,
      "aria-labelledby": labeledBy,
      onSelectAll,
      onSelectNone
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        style={style}
        className={`${className} CheckboxMenu`}
        aria-labelledby={labeledBy}
      >
        <div
          className="d-flex flex-column"
          style={{ maxHeight: "calc(100vh)", overflow: "none" }}
        >
          <ul
            className="list-unstyled flex-shrink mb-0"
            style={{ overflow: "auto" }}
          >
            {children}  
          </ul>
          <div className="dropdown-item border-top pt-2 pb-0">
            <ButtonGroup size="sm">
              <Button variant="link" onClick={onSelectAll}>
                Select All
              </Button>
              <Button variant="link" onClick={onSelectNone}>
                Select None
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
    );
  }
);

const CheckDropdownItem = React.forwardRef(
  ({ children, id, checked, onChange, disabledColum }, ref) => {
    //const disabledColum = ['tradingSymbol','product','netQuantity','ltp','totalPNL']
 
    return (
      <Form.Group ref={ref} className="dropdown-item mb-0" controlId={id}>
        <Form.Check
          type="checkbox"
          label={children}
          checked={checked}
          onChange={onChange && onChange.bind(onChange, id)}
          disabled={disabledColum.includes(id)}
        />
      </Form.Group>
    );
  }
);

 const CheckboxDropdown = ({ items, setColumns, disabledColum, hideColum }) => {

  const handleChecked = (key, event) => {
   // items.find(i => i.accessorKey === key).enableColumn = event.target.checked;
   
    setColumns(items.map(i => {
      if(i.accessorKey === key) {
        i.enableColumn = event.target.checked
      }

      if(key === "deltaCE" && i.accessorKey === "deltaPE") {
        i.enableColumn = event.target.checked
      }

      if(key === "oiChgCE" && i.accessorKey === "oiChgPE") {
        i.enableColumn = event.target.checked
      }

      if(key === "oiCE" && i.accessorKey === "oiPE") {
        i.enableColumn = event.target.checked
      }
     
      return i;
    }))
  };

  const handleSelectAll = () => {
 
     setColumns(items.map(i => {
      i.enableColumn = true;
      return i;
    }));
  };

  const handleSelectNone = () => {
   setColumns(items.map(i => {
    if(disabledColum.includes(i.accessorKey)) {
      i.enableColumn = true;
    }else {
      i.enableColumn = false;
    }
    return i;
  }));
  };
 
  return (
    <Dropdown className="columns-select" >
      <Dropdown.Toggle variant="none" id="dropdown-basic">
        Columns
      </Dropdown.Toggle>

      <Dropdown.Menu
        as={CheckboxMenu} 
        onSelectAll={handleSelectAll}
        onSelectNone={handleSelectNone}
        className="setting-dropdown"
      >
        {items.map(i => (
          <React.Fragment key={i.accessorKey}>
            {!hideColum.includes(i.accessorKey) &&
              <Dropdown.Item
                key={i.accessorKey}
                as={CheckDropdownItem}
                id={i.accessorKey}
                checked={i.enableColumn}
                onChange={handleChecked}
                disabledColum={disabledColum}
                hideColum={hideColum}
            
              >
                {i.header}
              </Dropdown.Item>
            }
          </React.Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
 };
export default CheckboxDropdown